import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

const styles = theme => ({
  progress: {
    margin: theme.spacing.unit * 1.5,
  },
});

function LoadingWheel(props) {
  const { classes } = props;
  return (

    <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    }}>

    {/* <div  style={{marginTop: "200px"}} className="col-md-6 col-md-offset-5"> */}
            
      <CircularProgress 
      size="80"
      thickness={6}
      className={classes.progress} />
    </div>
  );
}

LoadingWheel.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(LoadingWheel);


// WEBPACK FOOTER //
// ./src/components/Loader.js